import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { SOSCountry } from '../../data/sosNumbers';
import SOSButton from './SOSButton';

/**
 * @component MoreHelpAccordion
 * @description Acordeón expandible con servicios adicionales de emergencia
 */

interface MoreHelpAccordionProps {
  /** Datos del país */
  country: SOSCountry;
  /** Función para tracking de analytics */
  onSOSClick?: (service: string, country: string, location: string) => void;
}

const MoreHelpAccordion: React.FC<MoreHelpAccordionProps> = ({
  country,
  onSOSClick
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // No mostrar acordeón si no hay servicios adicionales
  if (!country.ayudas || country.ayudas.length === 0) {
    return null;
  }

  return (
    <div className="border border-gray-200 rounded-lg">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-inset"
        aria-expanded={isExpanded}
        aria-controls="more-help-content"
        type="button"
      >
        <div>
          <h3 className="text-lg font-semibold text-gray-900">
            Más ayudas
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            Servicios adicionales de emergencia en {country.nombre}
          </p>
        </div>
        {isExpanded ? (
          <ChevronUp className="h-5 w-5 text-gray-500" />
        ) : (
          <ChevronDown className="h-5 w-5 text-gray-500" />
        )}
      </button>

      {isExpanded && (
        <div 
          id="more-help-content"
          className="px-6 pb-6 border-t border-gray-200"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
            {country.ayudas.map((service) => (
              <SOSButton
                key={service.numero}
                service={service}
                country={country.id}
                location="sos_page"
                onSOSClick={onSOSClick}
                size="medium"
                showDescription={true}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MoreHelpAccordion;
